import { Button, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import useExpenseAPI, { loadExpenseImages } from '../apis/expenseAPI';
import BreadCumbNav from '../../globalComponents/BreadCumbNav';
import GoBack from '../../globalComponents/GoBack';
import EventEmitter from '../../utils/eventEmitter';



const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium dark:text-white',
  },
  {
    title: 'Action',
    key: 'operation',
    // width: '20%',
    fixed: 'right',
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',

  }
]


const ExpenseImages = () => {
  const loader = useLoaderData();
  const params = useParams();
  const navigate = useNavigate();
  const { removeImage } = useExpenseAPI();
  const { success } = useOutletContext();

  const onDelete = async (record) => {
    // console.log(record)
    removeImage(params.id, record, success);
  }

  columns[1].render = (_, record) => (
    <Button danger onClick={()=> onDelete(record)}>DELETE</Button>
  )

  const onRow = () => {

  }

  useEffect(() => {
    EventEmitter.subscribe('expensedelete', data => {
      navigate('/expense/expenses/'+params.action+'/images/'+params.id)
    });

    return () => EventEmitter.unsubscribe('expensedelete');
  },[])

  return (
    <div>
      <div className='flex justify-between mx-4 mb-4'>
        <h3 className='font-bold'><GoBack />Back</h3>
      </div>
      <Table
        rowKey={'name'}
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={loader}
        columns={columns}
        // scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default ExpenseImages;